import React, { useState, useRef } from 'react'
import { Form, Button, Alert, Badge } from "react-bootstrap";
import { serGetNameFu, serGetOldDateFu, serGetNewDateFu, serGetTelFu,
  serGetQuesFu, serGetAnswerFu, serGetLogoutFu } from '../../axios';
import langList from '../../utils/languagelist.json'
import { useSelector } from 'react-redux';



export default function Screening() {
  const [inputValue,setInputValue]=useState('')
  const [optionValue,setOptionValue]=useState('')
  // 查询全部数据展示列表
  const [backList,setBackList]=useState([]);
  // 重复数最多的展示列表
  const [screenList,setScreenList]=useState([])
  // 查询的全部数据，格式：[['a','b','c'],['e','f','g']]
  const backData=useRef([])

  // 信息对话框
  const [msgInfo, setMsgInfo] = useState('');
  const {lg}=useSelector((state)=>state.language)
  // 显示数据
  function showData(data){
    // 保存返回的数据
    const results=data.map(v=>v.hehe)
    backData.current=[results,...backData.current]
    // 查询的全部显示列表
    const list1=optionStr(optionValue)+':'+inputValue;
    let list2='';
    data.forEach(v => list2=list2+v.hehe+',');
    setBackList([list1,list2,...backList])
    // 最多次数显示列表
    setScreenList(maxList())
  }

  const handleBtnClick=() => {
    if(msgInfo) return;
    if(!optionValue||(optionValue*1<7&&!inputValue)){
      setMsgInfo(`0${langList.screening18[lg]}`);
      return;
    };
    if(optionValue==='1'){
      const regex = /^[a-zA-Z0-9@.*^$]*$/;
      if (!regex.test(inputValue)) {
        setMsgInfo(`0${langList.screening21[lg]}`);
        return;
      };
      let value=inputValue.replace(/\*+/g,'*');//多个***变为*
      value=value.replace(/\$.*/,'$');//去掉$右边的内容
      value=value.replace(/.*\^/,'^');//去掉^左边的内容
      serGetNameFu({name:value})
      .then(res=>{
        const code=res.code;
        if(code===44){
          showData(res.data)
        }else{
          setMsgInfo(`0${langList.screening20[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      })
    }else if(optionValue==='2'){
      const regex = /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[12]\d|3[01])$/;
      if (!regex.test(inputValue)) {
        setMsgInfo(`0${langList.screening22[lg]}`);
        return;
      };
      serGetOldDateFu({oldd:inputValue})
      .then(res=>{
        const code=res.code;
        if(code===45){
          showData(res.data)
        }else{
          setMsgInfo(`0${langList.screening20[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      })
    }else if(optionValue==='3'){
      const regex = /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[12]\d|3[01])$/;
      if (!regex.test(inputValue)) {
        setMsgInfo(`0${langList.screening22[lg]}`);
        return;
      };
      serGetNewDateFu({newd:inputValue})
      .then(res=>{
        const code=res.code;
        if(code===46){
          showData(res.data)
        }else{
          setMsgInfo(`0${langList.screening20[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      })
    }else if(optionValue==='4'){
      const regex = /^[0-9*^$]*$/;
      if (!regex.test(inputValue)) {
        setMsgInfo(`0${langList.screening21[lg]}`);
        return;
      };
      let value=inputValue.replace(/\*+/g,'*');//多个***变为*
      value=value.replace(/\$.*/,'$');//去掉$右边的内容
      value=value.replace(/.*\^/,'^');//去掉^左边的内容
      serGetTelFu({name:value})
      .then(res=>{
        const code=res.code;
        if(code===47){
          showData(res.data)
        }else{
          setMsgInfo(`0${langList.screening20[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      })
    }else if(optionValue==='5'){
      const regex = /^[\u4e00-\u9fa5a-zA-Z0-9*^$]*$/;
      if (!regex.test(inputValue)) {
        setMsgInfo(`0${langList.screening21[lg]}`);
        return;
      };
      let value=inputValue.replace(/\*+/g,'*');//多个***变为*
      value=value.replace(/\$.*/,'$');//去掉$右边的内容
      value=value.replace(/.*\^/,'^');//去掉^左边的内容
      serGetQuesFu({name:value})
      .then(res=>{
        const code=res.code;
        if(code===48){
          showData(res.data)
        }else{
          setMsgInfo(`0${langList.screening20[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      })
    }else if(optionValue==='6'){
      const regex = /^[\u4e00-\u9fa5a-zA-Z0-9*^$]*$/;
      if (!regex.test(inputValue)) {
        setMsgInfo(`0${langList.screening21[lg]}`);
        return;
      };
      let value=inputValue.replace(/\*+/g,'*');//多个***变为*
      value=value.replace(/\$.*/,'$');//去掉$右边的内容
      value=value.replace(/.*\^/,'^');//去掉^左边的内容
      serGetAnswerFu({name:value})
      .then(res=>{
        const code=res.code;
        if(code===48){
          showData(res.data)
        }else{
          setMsgInfo(`0${langList.screening20[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      })
    }else if(optionValue*1>=7){
      serGetLogoutFu({ovalue:optionValue})
      .then(res=>{
        const code=res.code;
        if(code===49){
          showData(res.data)
        }else if(code===50){
          setMsgInfo(`0${langList.screening19[lg]}`);
        }else{
          setMsgInfo(`0${langList.screening20[lg]}`);
        };
      })
      .catch(err =>{
        setMsgInfo('0'+err.message);
      })
    }
  };

  const handledeleteList=(e) => {
    const n=e.target.getAttribute('imgid')
    const i=n/2
    // 删除元素
    backData.current.splice(i,1);
    // 删除全部显示列表
    setBackList(prevList => [...prevList.slice(0, n), ...prevList.slice(n+2)]);
    // 最多次数显示列表
    setScreenList(maxList())
  }

  const handleSelectChang=(e) => {
    setOptionValue(e.target.value);
    setInputValue('')
  }
  
  function maxList(){
    let nameCount={};
    let maxCount=0;
    let maxNamelist=[];
    backData.current.flat().forEach(v =>{
      nameCount[v]=(nameCount[v] || 0) + 1;
      if(nameCount[v]>1){
        if(nameCount[v]===maxCount){
          maxNamelist.push(`${v}(${nameCount[v]})`)
        }else if(nameCount[v]>maxCount){
          maxCount=nameCount[v]
          maxNamelist=[`${v}(${nameCount[v]})`]
        };
      }
    });
    return maxNamelist
  }
  
  // 提示框
  const chip=(
    <Alert show={msgInfo===''?false:true} 
      variant={msgInfo.substring(0,1)==='0'?'danger':'success'} 
      className='py-1 text-center text-danger w-100'
    >
      {msgInfo.substring(1)}
    </Alert>
  )
  if(msgInfo){
    setTimeout(() => {
      setMsgInfo('');
    }, 5000);
  };

  function optionStr(str){
    switch (str) {
      case '1':
        return `${langList.screening1[lg]}`;
      case '2':
        return `${langList.screening2[lg]}`;
      case '3':
        return `${langList.screening3[lg]}`;
      case '4':
        return `${langList.screening4[lg]}`;
      case '5':
        return `${langList.screening5[lg]}`;
      case '6':
        return `${langList.screening6[lg]}`;
      case '7':
        return `${langList.screening7[lg]}`;
      case '8':
        return `${langList.screening8[lg]}`;
      case '9':
        return `${langList.screening9[lg]}`;
      case '10':
        return `${langList.screening10[lg]}`;
      case '11':
        return `${langList.screening11[lg]}`;
      default:
        return '';
    }
  }
  
  return (
    <div>
      <Form.Select id='selectscreen' className='mt-3'
        value={optionValue}
        onChange={handleSelectChang}
      >
        <option value=''>{langList.screening13[lg]}</option>
        <option value='1'>{langList.screening1[lg]}</option>
        <option value='2'>{langList.screening2[lg]}</option>
        <option value='3'>{langList.screening3[lg]}</option>
        <option value='4'>{langList.screening4[lg]}</option>
        <option value="5">{langList.screening5[lg]}</option>
        <option value="6">{langList.screening6[lg]}</option>
        <option value="7">{langList.screening7[lg]}</option>
        <option value="8">{langList.screening8[lg]}</option>
        <option value="9">{langList.screening9[lg]}</option>
        <option value="10">{langList.screening10[lg]}</option>
        <option value="11">{langList.screening11[lg]}</option>
      </Form.Select>
      <Form.Control id='inputscreen' type="text" className='mt-3'
        placeholder={optionValue*1>6?'':`${langList.screening12[lg]}`}
        value={inputValue} disabled={optionValue*1>6?true:false}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className='text-center'>
        {langList.screening14[lg]}:<Badge bg="secondary" className='mx-1'>*</Badge>&nbsp;
        <Badge bg="secondary" className='mx-1'>^</Badge>&nbsp;
        <Badge bg="secondary" className='mx-1'>$</Badge>
      </div>
      {msgInfo && chip}
      <div className='text-center mt-4 mb-3'>
        <Button variant="primary" className='w-25'
          onClick={handleBtnClick}
        >{langList.public6[lg]}</Button>
      </div>
      <Alert variant="success" className='overflow-auto' style={{height: '108px'}}>
        {screenList && screenList.map((v,i)=><div key={'screen'+i}>{v}</div>)}
      </Alert>
      <Alert variant="light" className='overflow-auto' style={{height: '200px'}}>
        {backList.map((v,i) => (
          <div key={'backlist'+i}>
            { i%2===0 &&
              <img src='./pic/x.svg' alt='' width={'16px'} style={{cursor:'pointer'}}
              onMouseOver={(e) => e.currentTarget.src = './pic/x-square2.svg'}
              onMouseOut={(e) => e.currentTarget.src = './pic/x.svg'}
              onClick={handledeleteList} imgid={i}/>}
            <span style={{wordWrap:'break-word'}}>{v}</span>
            { i%2===1 && <hr/>}
          </div>
        ))}
      </Alert>
    </div>
  );
}
